"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventContext = void 0;
var EventContext = /** @class */ (function () {
    function EventContext(name, version, fields) {
        this.name = name;
        this.ts_ms = Date.now();
        this.version = version;
        this.fields = fields;
    }
    EventContext.getAttributeTypeMap = function () {
        return EventContext.attributeTypeMap;
    };
    EventContext.attributeTypeMap = [
        {
            name: 'name',
            baseName: 'name',
            type: 'string',
        },
        {
            name: 'ts_ms',
            baseName: 'ts_ms',
            type: 'number',
        },
        {
            name: 'version',
            baseName: 'version',
            type: 'number',
        },
        {
            name: 'fields',
            baseName: 'fields',
            type: 'object',
        },
    ];
    return EventContext;
}());
exports.EventContext = EventContext;
//# sourceMappingURL=eventcontext.js.map